// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__1c45t","link":"footer_link__3Nzyu","icon":"footer_icon__EDTqg"};